module.exports = __webpack_public_path__ + "static/media/emotion_detect_demo.127451c3.png";